export default __webpack_public_path__ + "static/media/user_list_cols.ee3a5ea0.png";